$(function () {
let manualSlideOut = $('.manual-slide-out');
    $('.button-collapse').click(function () {
        let target = $('#' + $(this).data('activates'));

        if (target.length) {
            let openClass = 'side-nav--open';
            let sideNavOverlay = $('#sidenav-overlay');
            // test if it was a manual call
            if (target.hasClass('manual-slide-out--close')) {
                manualSlideOut.click();
            } else {
                if (target.hasClass(openClass)) {
                    target.removeClass(openClass);
                    sideNavOverlay.remove();
                } else {
                    target.addClass(openClass);
                    $('body').append('<div id="sidenav-overlay" class="sidenav-overlay"></div>');
                }
                sideNavOverlay.click(function () {
                    $(this).remove();
                    target.removeClass(openClass);
                });
            }
        }
    });
    manualSlideOut.click(function (e) {
        e.preventDefault();
        let target = $('.side-nav.fixed'),
        close = true;

        if (target.hasClass('manual-slide-out--close')) {
            target.removeClass('manual-slide-out--close');
            $('#main-container').removeClass('manual-slide-out--active');
            close = false;
        } else {
            target.addClass('manual-slide-out--close');
            $('#main-container').addClass('manual-slide-out--active');
        }
        let closerRoute = $('body').attr('data-manual-route');
        $.ajax({
            url: closerRoute,
            method: 'post',
            data: {
                _token: $('input[name="_token"]').val(),
                'manual-slide-out--close': close
            }
        });

    });
    /**
     * trigger single item btm floating
     */
    $('.btn-floating--single').click(function () {

        if ($(this).is('[href]')) {
            window.location.href = $(this).attr('href');
        }

        if ($(this).is('button') || $(this).is('submit')) {
            // find the form parent
            $(this).closest('form').submit();
        }
    });

    /**
     * Enable all tooltips
     */
    $('[data-toggle="tooltip"]').tooltip({
        html: true
    });

    $('#switch-skin').find('.switch-skin').click(function (e) {
        e.preventDefault();

        let skin = $(this).attr('data-skin'),
            body = $('body');

        if (typeof skin !== 'undefined') {
            let bodySkin = body.attr('data-skin').trim(),
                bodyRoute = body.attr('data-skin-route').trim()
            ;
//            console.log('bodySkin', 'prev bodySkin','>'+bodySkin+'<','new->'+skin+'<');
            body
                .removeClass(bodySkin)
                .addClass(skin);

            body.attr('data-skin', skin);


            $.ajax({
                url: bodyRoute,
                method: 'post',
                data: {
                    _token: $('input[name="_token"]').val(),
                    skin: skin
                }
            });

        }
        // console.log('$(this).data("skin")', $(this).data("skin"));
    });
});

/**
 * OpenAuth prebuilt stuff
 */
$.fn.extend({

    toggleText: function (a, b) {
        return this.text(this.text() == b ? a : b);
    },

    /**
     * Remove element classes with wildcard matching. Optionally add classes:
     *   $( '#foo' ).alterClass( 'foo-* bar-*', 'foobar' )
     *
     */
    alterClass: function (removals, additions) {

        let self = this;

        if (removals.indexOf('*') === -1) {
            // Use native jQuery methods if there is no wildcard matching
            self.removeClass(removals);
            return !additions ? self : self.addClass(additions);
        }

        let pattern = new RegExp('\\s' +
            removals.replace(/\*/g, '[A-Za-z0-9-_]+').split(' ').join('\\s|\\s') +
            '\\s', 'g');

        self.each(function (i, it) {
            let cn = ' ' + it.className + ' ';
            while (pattern.test(cn)) {
                cn = cn.replace(pattern, ' ');
            }
            it.className = $.trim(cn);
        });

        return !additions ? self : self.addClass(additions);
    }

});



// WEBPACK FOOTER //
// ./resources/assets/js/bootstrap.js